import styled from 'styled-components';

export const DpSearch = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
`;
export const DpSearchContent = styled.div`
  max-width: 500px;
  width: 100%;
  padding: 0 15px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FilterButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 15px;
  margin-right: auto;
  flex-direction: row;
  justify-content: space-around;
`;
export const FilterButton = styled.div`
cursor: pointer;
font-weight: 600;
  background-color: ${({ activeBtn }) => (activeBtn ? '#fafafa' : '#fff')};
  padding: 5px 10px;
  border-radius: 15px;
`;

export const NewLabel = styled.div`
  color: #207936;
  font-size: 12px;
  font-weight: 600;
  line-height: 15px;
  position: absolute;
  top: 20px;
  left: 20px;
  padding: 2px 7px;
  border-radius: 15px;
  background-color: #ebf9ee;
`;

export const SignInBtn = styled.button`
  background: #ffffff;
  color: #4b4b4d;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  margin-left: auto;
  @media (max-width: 610px) {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    margin-right: 12px;
  }
`;

export const HeaderPage = styled.div`
  display: flex;
  width: 100%;
  padding: 48px 0px 0px 0px;
  p {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 29px;
    color: #222224;
  }
`;
export const SearchField = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 32px;
  padding-bottom: 16px;
`;
export const SearchContainer = styled.div`
  ${(props) => props.table && 'border: 1px solid #ECEDF0'}
  background: ${(props) => (props.table ? '#ffffff' : '#fafafa')};
  border-radius: 36px;
  padding: ${(props) => (props.table ? '12px 16px' : '20px 32px')};
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: 16px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  input {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }
  svg {
    margin-right: 8px;
  }
  .react-datepicker {
    position: absolute;
    left: -30px;
    top: 13px;
  }
`;
export const SearchInput = styled.input`
  font-style: normal;
  width: 100%;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #4b4b4d;
  background: ${(props) => (props.table ? '#ffffff' : '#fafafa')};
  ::placeholder {
    font-style: normal;
    font-weight: normal;
    font-size: ${(props) => (props.table ? '14px' : '16px')};
    line-height: ${(props) => (props.table ? '17px' : '24px')};
    color: ${(props) => (props.table ? '#7F7F82' : '#4b4b4d')};
  }
`;
export const CancelBtn = styled.button`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #222224;
  padding: 8px 8px 8px 0px;
  background: none;
`;

export const ListResultSearch = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.center ? 'center' : 'none')};
  flex-direction: column;
  max-width: 375px;
  height: 100vh;
  position: relative;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 0;
  }
`;
export const FindDP = styled.div`
  display: flex;
  max-width: 180px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  span {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 30px;
    color: #4b4b4d;
    margin-top: 27px;
  }
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  margin-top: 30px;
  ${(props) => props.absolute && 'position: absolute;'}
  ${(props) => props.absolute && 'bottom: 0px;'}

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    color: #7f7f82;

    :hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

export const DpContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid #ecedf0;
  padding: 32px 0;
  height: fit-content;

  &:first-child {
    padding-top: 16px;
  }
`;

export const DpItem = styled.div`
  width: 100%;
  height: 284px;
  position: relative;
  padding: 16px 20px;
  border-radius: 16px;
  cursor: pointer;
  background-position: center;
  background-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.66) 100%
    ),
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.1) 0%,
      rgba(0, 0, 0, 0) 37.5%,
      rgba(0, 0, 0, 0.66) 100%
    ),
    url(${(props) => props.preview});
  svg {
    width: 100%;
  }
`;

export const DpDescription = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  justify-content: flex-end;

  span {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #ecedf0;
  }
  p {
    font-style: normal;
    font-weight: 800;
    font-size: 28px;
    line-height: 34px;
    color: #ffffff;
  }
`;

export const PendingLabel = styled.span`
  width: 73px;
  height: 19px;

  background: #EBF5FF;
  border-radius: 10px;
  padding: 2px 8px;

  font-family: 'Inter';
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  line-height: 15px !important;
  letter-spacing: 0.04em !important;
  text-transform: uppercase !important;
  color: #0A84FF !important;
`;